var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69482 22.5H15.6948C20.6948 22.5 22.6948 20.5 22.6948 15.5V9.5C22.6948 4.5 20.6948 2.5 15.6948 2.5H9.69482C4.69482 2.5 2.69482 4.5 2.69482 9.5V15.5C2.69482 20.5 4.69482 22.5 9.69482 22.5Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6948 2.94043V12.9204C17.6948 14.8904 16.2848 15.6604 14.5548 14.6204L13.2348 13.8304C12.9348 13.6504 12.4548 13.6504 12.1548 13.8304L10.8348 14.6204C9.10482 15.6504 7.69482 14.8904 7.69482 12.9204V2.94043",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69482 22.5H15.6948C20.6948 22.5 22.6948 20.5 22.6948 15.5V9.5C22.6948 4.5 20.6948 2.5 15.6948 2.5H9.69482C4.69482 2.5 2.69482 4.5 2.69482 9.5V15.5C2.69482 20.5 4.69482 22.5 9.69482 22.5Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6948 2.94043V12.9204C17.6948 14.8904 16.2848 15.6604 14.5548 14.6204L13.2348 13.8304C12.9348 13.6504 12.4548 13.6504 12.1548 13.8304L10.8348 14.6204C9.10482 15.6504 7.69482 14.8904 7.69482 12.9204V2.94043",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.ba3919f2692851384d4ca798ebdfaaad.svg";
export { ForwardRef as ReactComponent };